module.exports = __webpack_public_path__ + "img/headerCenter.3d5d6dfb.png";